









import { Component, Prop, Vue } from 'vue-property-decorator';
import { personas } from '@/data';
import PersonaTagVue from '@/components/PersonaTag.vue';

@Component({
  components: {
    PersonaTagVue,
  },
})
export default class SimpleComponent extends Vue {
  public personas = personas;
}
